import React from 'react'
import MarkPackagedPage from './MarkPackagedPage'

function MarkPackagedPageContainer() {
    return (
        <div className="MarkPackagedPageContainer">
            <MarkPackagedPage/>
        </div>
    )
}

export default MarkPackagedPageContainer